import { compose } from "redux";
import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core";

import WorkScheduleReportItem from "features/planner/report/workSchedule/components/WorkScheduleReportItem";
import WorkScheduleReportBase from "features/planner/report/workSchedule/components/WorkScheduleReportBase";
import WorkScheduleYearReportWorkWeek from "features/planner/report/workSchedule/components/year/WorkScheduleYearReportWorkWeek";

class WorkScheduleYearReport extends PureComponent {
  renderDate = (employeeCard, date, index) => {
    const { classes } = this.props;

    const workWeek = employeeCard
      .get("scheduleWeeks")
      .find(x => x.get("weekStartDate").isSame(date, "isoWeek"));

    return workWeek ? (
      <WorkScheduleYearReportWorkWeek key={index} workWeek={workWeek} />
    ) : (
      <WorkScheduleReportItem
        key={index}
        classes={{
          root: classes.workScheduleReportItem,
        }}
      />
    );
  };

  render() {
    const { dates, report } = this.props;

    return (
      <WorkScheduleReportBase
        dates={dates}
        report={report}
        renderDate={this.renderDate}
      />
    );
  }
}

const styles = theme => ({
  workScheduleReportItem: {
    borderLeft: theme.altus.workScheduleReport.defaultBorder,
    "&:first-of-type": {
      borderLeft: 0,
    },
    "& + $workScheduleReportItem": {
      borderLeft: theme.altus.workScheduleReport.placeholderBorder,
    },
  },
});

export default compose(withStyles(styles))(WorkScheduleYearReport);
